import React, { useState } from "react";

const OverlappingLogos = ({ platforms = [], name }) => {
  const [isHovered, setIsHovered] = useState(false);

  const extractPlatforms = (name) => {
    const possiblePlatforms = [
      "flexport",
      "transmission",
      "portpro",
      "e2open",
      "rectangle",
      "crown",
    ];
    return possiblePlatforms.filter((platform) =>
      name.toLowerCase().includes(platform)
    );
  };

  const displayPlatforms =
    platforms.length > 0 ? platforms : extractPlatforms(name || "");

  const reversedDisplayPlatforms = [...displayPlatforms];
  return (
    <div
      className="relative cursor-pointer"
      style={{
        width: 40,
        height: "20px",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {reversedDisplayPlatforms.map((platform, index) => (
        <div
          key={index}
          style={{
            width: 22,
            height: 22,
            borderWidth: 2.5,
            borderRadius: 7,
            left: `${index * 14}px`,
            zIndex: displayPlatforms.length - index,
          }}
          className={`absolute overflow-hidden border-white shadow-sm bg-slate-${
            300 + index * 100
          } rounded-md transition-all duration-300 ease-in-out ${
            isHovered
              ? `transform -translate-x-${index + 1} -translate-y-${
                  index + 1
                } rotate-${[-15, 0, 15][index % 3]}deg`
              : `transform rotate-${[-1, 0, 1][index % 3]}deg`
          }`}
        >
          <img src={`./logos/${platform.toLowerCase()}.png`} alt={platform} />
        </div>
      ))}
    </div>
  );
};

export default OverlappingLogos;
